export enum ProgressTrackerModeEnum {
  Public = 'public',
  Private = 'private',
}
